webpackJsonp([91],{

/***/ 1850:
/***/ (function(module, exports) {

/**
 * This file will load a hidden div that will allow us to know if there is an ad blocker.
 * The filename "ads.js" is part of the blacklisted terms used by ad blockers.
 * So if our div is loaded it will mean our file hasn't been blocked.
 * more info: https://www.detectadblock.com
 */

var e = document.createElement('div');
e.id = 'GamqTMFIkrvA'; // the obscure div id is to ensure that it doesn't conflict with any other div's we have
e.style.display = 'none';
document.body.appendChild(e);

/***/ })

},[1850]);


// WEBPACK FOOTER //
// javascripts/ads.js